import React, { useState, useEffect, useMemo } from 'react';
import { Button } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { deleteModuleRequest, updateModuleRequest } from 'store/actions';
import CreateModule from './CreateModule';
import ConfirmationModal from 'components/Modals/ConfirmationModal';
import { MdDeleteOutline } from 'react-icons/md';
import { FaRegEdit } from 'react-icons/fa';
import Cookies from 'js-cookie';
import ModuleDataTable from 'components/TableContainers/ModuleDataTable';

const ModuleTable = ({ modules, loading, totalrows, courses,courseOptions }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);

  const [selectedSortData, setSelectedSortData] = useState({ value: 'createdAt', direction: 'desc' });
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchString, setSearchString] = useState('');

  const permissions = JSON.parse(localStorage.getItem('permissions'));
  const hasEditPermission = permissions?.some(item => item?.permission_name === 'Edit Module');
  const hasDeletePermission = permissions?.some(item => item?.permission_name === 'Delete Module');

  useEffect(() => {
    if (deleteId && confirmAction) {
      dispatch(deleteModuleRequest(deleteId));
      setOpenModal(false);
      setConfirmAction(false);
    }
  }, [confirmAction]);

const columns = useMemo(() => [
  {
    header: 'Title',
    accessorKey: 'title',
    cell: ({ row }) => (
      <div
        style={{
          maxWidth: '220px',
          whiteSpace: 'normal',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          wordWrap: 'break-word',
          lineHeight: '1.4',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          color: '#222',
        }}
        title={row.original.title}
      >
        {row.original.title || '-'}
      </div>
    ),
  },
  {
    header: 'Order',
    accessorKey: 'orderIndex',
  },
  {
    header: 'Course',
    accessorKey: 'courseId.title',
    cell: ({ row }) => (
      <div
        style={{
          maxWidth: '250px',
          whiteSpace: 'normal',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          wordWrap: 'break-word',
          lineHeight: '1.4',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          color: '#444',
        }}
        title={row.original?.courseId?.title}
      >
        {row.original?.courseId?.title || '-'}
      </div>
    ),
    showFilter: false,
  },
  ...(hasEditPermission || hasDeletePermission
    ? [
        {
          header: 'Actions',
          id: 'actions',
          cell: ({ row }) => {
            const handleEdit = () => {
              setEditData(row.original);
              setIsOpen(true);
            };
            const handleDelete = () => {
              setDeleteId(row.original._id);
              setOpenModal(true);
            };
            return (
              <div className="d-flex gap-2">
                {hasEditPermission && (
                  <Button color="primary" onClick={handleEdit} title="Edit">
                    <FaRegEdit size={18} />
                  </Button>
                )}
                {hasDeletePermission && (
                  <Button color="danger" onClick={handleDelete} title="Delete">
                    <MdDeleteOutline size={18} />
                  </Button>
                )}
              </div>
            );
          },
          showFilter: false,
        },
      ]
    : []),
], [hasEditPermission, hasDeletePermission]);


  const handleFormSubmit = (id, data, onClose) => {
    dispatch(updateModuleRequest(id, data, onClose));
  };

  return (
    <>
      <ConfirmationModal
        okText="Confirm"
        onCancel={() => setOpenModal(false)}
        onOk={() => setConfirmAction(true)}
        isVisible={openModal}
        title="Delete Module"
        content="Are you sure you want to delete this module?"
      />

      <CreateModule
        visible={isOpen}
        initialData={editData}
        onSubmit={handleFormSubmit}
        handleClose={() => setIsOpen(false)}
        courses={courses}
        courseOptions={courseOptions}
      />

      <div className="container-fluid">
        <ModuleDataTable
          columns={columns}
          loading={loading}
          data={modules || []}
          isGlobalFilter
          isPagination
          selectedSortData={selectedSortData}
          setSelectedSortData={setSelectedSortData}
          pageIndex={pageIndex}
          setPageIndex={setPageIndex}
          setPageSize={setPageSize}
          pageSize={pageSize}
          setSearchString={setSearchString}
          searchString={searchString}
          SearchPlaceholder="Search modules..."
          pagination="pagination"
          docName="Modules"
          totalrows={totalrows}
          courseOptions={courseOptions}
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      </div>
    </>
  );
};

export default ModuleTable;
